export default __webpack_public_path__ + "static/media/kitchen5-beforeD-1024w.b64b5296.png";